const brush = (state = null, action)=>{
    if(action.type === "SET_BRUSH"){
        state = action.brush
    }
    if(action.type === "RESET_CANVAS"){
        state = null;
    }

    return state;
}

export default brush;